import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { passwordsMatchValidator } from '../../../shared/validators';
import { RegisterModel } from '../../auth-models';

@Component({
    selector: 'app-register-form',
    templateUrl: './register-form.component.html',
    styleUrls: ['./register-form.component.scss'],
    standalone: false
})
export class RegisterFormComponent implements OnInit {
  @Input() registerError: string;
  @Output() submitted = new EventEmitter<RegisterModel>();

  /*
  // Moved to ngOnInit to avoid initialization errors.
  registerForm = this.fb.group(
    {
      email: [
        'test1@example.com',
        {
          validators: [Validators.required, Validators.email],
        },
      ],
      firstName: ['Test', { validators: [Validators.required] }],
      lastName: ['User1', { validators: [Validators.required] }],
      password: ['Password1!', { validators: [Validators.required] }],
      confirmedPassword: ['Password1!', { validators: [Validators.required] }],
      rememberMe: false,
    },
    { updateOn: 'blur', validators: passwordsMatchValidator }
  );
  */
 registerForm: FormGroup;

  get email() {
    return this.registerForm.get('email');
  }

  get password() {
    return this.registerForm.get('password');
  }

  get firstName() {
    return this.registerForm.get('firstName');
  }

  get lastName() {
    return this.registerForm.get('lastName');
  }

  get confirmedPassword() {
    return this.registerForm.get('confirmedPassword');
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit() {
    this.registerForm = this.fb.group(
      {
        email: [
          'test1@example.com',
          {
            validators: [Validators.required, Validators.email],
          },
        ],
        firstName: ['Test', { validators: [Validators.required] }],
        lastName: ['User1', { validators: [Validators.required] }],
        password: ['Password1!', { validators: [Validators.required] }],
        confirmedPassword: ['Password1!', { validators: [Validators.required] }],
        rememberMe: false,
      },
      { updateOn: 'blur', validators: passwordsMatchValidator }
    );
  }

  onSubmit() {
    this.registerForm.markAllAsTouched();
    this.registerForm.updateValueAndValidity();

    if (this.registerForm.valid) {
      this.submitted.emit(this.registerForm.value);
    }
  }

  getErrorMessage() {
    if (this.email.hasError('required')) return 'Email is required';
    if (this.email.hasError('email')) return 'Not a valid email';
    if (this.firstName.hasError('required')) return 'First name is required';
    if (this.lastName.hasError('required')) return 'Last name is required';
    if (this.password.hasError('required')) return 'Password is required';
    if (this.confirmedPassword.hasError('required'))
      return 'Confirm password is required';
    if (this.registerForm.hasError('passwordMismatch'))
      return 'Passwords must match';
    return '';
  }
}
